import { Avatar as DefaultAvatar, type AvatarProps } from 'js/components/Avatar'
import cx from 'js/lib/helpers/cx'

import styles from './Avatar.module.css'

// FIXME: for having option to put margin right we compose whole new version??
const Avatar = ({ className, ...rest }: AvatarProps) => (
    <DefaultAvatar className={cx(styles.avatar, className)} {...rest} />
)

export default Avatar
